import { configProxyApiInstance } from '../config';

const rootPath = `customers`;
export const getCustomers = () => configProxyApiInstance.get(`/${rootPath}/`);
